// @flow

import Resource from 'speed-js-core/src/api/NestedResource';

export default class ContactPersonResource extends Resource {
    basePath: string = 'sites/sites/{parent}/contact-people/';

    objectPath: string = 'sites/sites/{parent}/contact-people/{ident}/';
}
